// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-6ca73928],button[data-v-6ca73928]{padding:.5625rem 1.25rem;transition:color .25s ease-in-out,background-color .25s ease-in-out,border-color .25s ease-in-out}@media screen and (max-width:1023px){a[data-v-6ca73928],button[data-v-6ca73928]{padding:.4rem 1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
